import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import MobileNavigation from "./MobileNavigation";
// import SidebarNavigation from "./SidebarNavigation";
import { useLocation } from "react-router-dom";
import MetaContext from "../../store/meta-context";
import getTitle from "../utilities/getTitle";
import LanguageSelect from "../LanguageSelect";
import fetchMenu from "../rest-api/fetchMenu";

import styled from "styled-components";
const MyLink = styled(NavLink)`
  &.active {
    &:before {
      content: "";
      width: 50px;
      border-bottom: 2px solid;
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;
const Navigation = ({ menuItems, noreactrouter = false }) => {
  const metaCtx = useContext(MetaContext);
  if (!menuItems) {
    menuItems = fetchMenu();
  }
  console.log(metaCtx.title);
  // const menuItems = fetchMenu();
  // metaCtx.setTitle(getTitle(location));
  return (
    <>
      <header className="fixed w-full h-14 lg:h-24 bg-white border-b-2 flex z-50 font-nav text-xl">
        <span className="w-14 lg:w-24 h-full border-r-2 flex justify-center items-center">
          {noreactrouter ? (
            <a className="w-full text-center" href="/">
              <svg
                className="inline-block transform scale-75 lg:scale-100"
                width="25px"
                height="36px"
                viewBox="0 0 25 36"
              >
                <g strokeWidth="1" fill="none" fillRule="evenodd">
                  <g fill="#000000" fillRule="nonzero">
                    <path
                      d="M2.51508302,5.48454559e-06 C2.84938051,-0.0006661606 3.18093263,0.060355702 3.49308302,0.18001106 C3.79294073,0.291380915 4.06761627,0.461353402 4.30108302,0.68001106 C4.52635212,0.893073418 4.71072307,1.14556672 4.84508302,1.42501106 C4.98184372,1.70912363 5.05195736,2.0207018 5.05011963,2.33601106 C5.05011963,2.64310728 4.980039,2.94615788 4.84508302,3.22201106 C4.71072307,3.5014554 4.52635212,3.7539487 4.30108302,3.96701106 C4.06655236,4.18773823 3.7924046,4.36213421 3.49308302,4.48101106 C3.18288812,4.60895111 2.85062662,4.67485983 2.51508302,4.67502093 C2.18341429,4.67594697 1.85492992,4.6103181 1.54908302,4.48201106 C1.25298038,4.36151744 0.981743317,4.18724763 0.749083018,3.96801106 C0.523812785,3.75517944 0.339733144,3.50262082 0.206083018,3.22301106 C0.0702751061,2.94742067 -0.000214541883,2.64424674 4.06425999e-05,2.33701106 C-0.00194060461,2.02157368 0.0685391964,1.70988873 0.206083018,1.42601106 C0.340927661,1.14607871 0.526379512,0.89349804 0.753083018,0.68101106 C0.984620902,0.463806905 1.25638291,0.293955651 1.55308302,0.18101106 C1.8595445,0.0608241985 2.18589739,-0.000578996354 2.51508302,5.48454559e-06 M0.391083018,12.8420111 L3.45608302,11.5070111 L4.73608302,11.5070111 L4.73608302,35.4450111 L0.391083018,35.4450111 L0.391083018,12.8420111 Z"
                      id="Path_11045"
                    ></path>
                    <path
                      d="M12.413083,5.48454559e-06 C12.7473805,-0.0006661606 13.0789326,0.060355702 13.391083,0.18001106 C13.6910472,0.291163026 13.9657637,0.461160854 14.199083,0.68001106 C14.4243521,0.893073418 14.6087231,1.14556672 14.743083,1.42501106 C14.8798437,1.70912363 14.9499574,2.0207018 14.9481196,2.33601106 C14.9481196,2.64310728 14.878039,2.94615788 14.743083,3.22201106 C14.6087231,3.5014554 14.4243521,3.7539487 14.199083,3.96701106 C13.9647162,4.18794891 13.690526,4.36237192 13.391083,4.48101106 C13.0808881,4.60895111 12.7486266,4.67485983 12.413083,4.67502093 C12.0814143,4.67594697 11.7529299,4.6103181 11.447083,4.48201106 C11.1509804,4.36151744 10.8797433,4.18724763 10.647083,3.96801106 C10.4218128,3.75517944 10.2377331,3.50262082 10.104083,3.22301106 C9.96827511,2.94742067 9.89778546,2.64424674 9.89804064,2.33701106 C9.8960594,2.02157368 9.9665392,1.70988873 10.104083,1.42601106 C10.2389277,1.14607871 10.4243795,0.89349804 10.651083,0.68101106 C10.8826209,0.463806905 11.1543829,0.293955651 11.451083,0.18101106 C11.7575445,0.0608241985 12.0838974,-0.000578996354 12.413083,5.48454559e-06 M10.289083,12.8420111 L13.354083,11.5070111 L14.634083,11.5070111 L14.634083,35.4450111 L10.289083,35.4450111 L10.289083,12.8420111 Z"
                      id="Path_11046"
                    ></path>
                    <path
                      d="M22.311083,5.48454559e-06 C22.6453805,-0.0006661606 22.9769326,0.060355702 23.289083,0.18001106 C23.5890472,0.291163026 23.8637637,0.461160854 24.097083,0.68001106 C24.3223521,0.893073418 24.5067231,1.14556672 24.641083,1.42501106 C24.7778437,1.70912363 24.8479574,2.0207018 24.8461196,2.33601106 C24.8461196,2.64310728 24.776039,2.94615788 24.641083,3.22201106 C24.5067231,3.5014554 24.3223521,3.7539487 24.097083,3.96701106 C23.8627162,4.18794891 23.588526,4.36237192 23.289083,4.48101106 C22.9788881,4.60895111 22.6466266,4.67485983 22.311083,4.67502093 C21.9794143,4.67594697 21.6509299,4.6103181 21.345083,4.48201106 C21.0489804,4.36151744 20.7777433,4.18724763 20.545083,3.96801106 C20.3198128,3.75517944 20.1357331,3.50262082 20.002083,3.22301106 C19.8662751,2.94742067 19.7957855,2.64424674 19.7960406,2.33701106 C19.7940594,2.02157368 19.8645392,1.70988873 20.002083,1.42601106 C20.1369277,1.14607871 20.3223795,0.89349804 20.549083,0.68101106 C20.7806209,0.463806905 21.0523829,0.293955651 21.349083,0.18101106 C21.6555445,0.0608241985 21.9818974,-0.000578996354 22.311083,5.48454559e-06 M20.187083,12.8420111 L23.252083,11.5070111 L24.532083,11.5070111 L24.532083,35.4450111 L20.187083,35.4450111 L20.187083,12.8420111 Z"
                      id="Path_11047"
                    ></path>
                  </g>
                </g>
              </svg>
            </a>
          ) : (
            <Link className="w-full text-center" to="/">
              <svg
                className="inline-block transform scale-75 lg:scale-100"
                width="25px"
                height="36px"
                viewBox="0 0 25 36"
              >
                <g strokeWidth="1" fill="none" fillRule="evenodd">
                  <g fill="#000000" fillRule="nonzero">
                    <path
                      d="M2.51508302,5.48454559e-06 C2.84938051,-0.0006661606 3.18093263,0.060355702 3.49308302,0.18001106 C3.79294073,0.291380915 4.06761627,0.461353402 4.30108302,0.68001106 C4.52635212,0.893073418 4.71072307,1.14556672 4.84508302,1.42501106 C4.98184372,1.70912363 5.05195736,2.0207018 5.05011963,2.33601106 C5.05011963,2.64310728 4.980039,2.94615788 4.84508302,3.22201106 C4.71072307,3.5014554 4.52635212,3.7539487 4.30108302,3.96701106 C4.06655236,4.18773823 3.7924046,4.36213421 3.49308302,4.48101106 C3.18288812,4.60895111 2.85062662,4.67485983 2.51508302,4.67502093 C2.18341429,4.67594697 1.85492992,4.6103181 1.54908302,4.48201106 C1.25298038,4.36151744 0.981743317,4.18724763 0.749083018,3.96801106 C0.523812785,3.75517944 0.339733144,3.50262082 0.206083018,3.22301106 C0.0702751061,2.94742067 -0.000214541883,2.64424674 4.06425999e-05,2.33701106 C-0.00194060461,2.02157368 0.0685391964,1.70988873 0.206083018,1.42601106 C0.340927661,1.14607871 0.526379512,0.89349804 0.753083018,0.68101106 C0.984620902,0.463806905 1.25638291,0.293955651 1.55308302,0.18101106 C1.8595445,0.0608241985 2.18589739,-0.000578996354 2.51508302,5.48454559e-06 M0.391083018,12.8420111 L3.45608302,11.5070111 L4.73608302,11.5070111 L4.73608302,35.4450111 L0.391083018,35.4450111 L0.391083018,12.8420111 Z"
                      id="Path_11045"
                    ></path>
                    <path
                      d="M12.413083,5.48454559e-06 C12.7473805,-0.0006661606 13.0789326,0.060355702 13.391083,0.18001106 C13.6910472,0.291163026 13.9657637,0.461160854 14.199083,0.68001106 C14.4243521,0.893073418 14.6087231,1.14556672 14.743083,1.42501106 C14.8798437,1.70912363 14.9499574,2.0207018 14.9481196,2.33601106 C14.9481196,2.64310728 14.878039,2.94615788 14.743083,3.22201106 C14.6087231,3.5014554 14.4243521,3.7539487 14.199083,3.96701106 C13.9647162,4.18794891 13.690526,4.36237192 13.391083,4.48101106 C13.0808881,4.60895111 12.7486266,4.67485983 12.413083,4.67502093 C12.0814143,4.67594697 11.7529299,4.6103181 11.447083,4.48201106 C11.1509804,4.36151744 10.8797433,4.18724763 10.647083,3.96801106 C10.4218128,3.75517944 10.2377331,3.50262082 10.104083,3.22301106 C9.96827511,2.94742067 9.89778546,2.64424674 9.89804064,2.33701106 C9.8960594,2.02157368 9.9665392,1.70988873 10.104083,1.42601106 C10.2389277,1.14607871 10.4243795,0.89349804 10.651083,0.68101106 C10.8826209,0.463806905 11.1543829,0.293955651 11.451083,0.18101106 C11.7575445,0.0608241985 12.0838974,-0.000578996354 12.413083,5.48454559e-06 M10.289083,12.8420111 L13.354083,11.5070111 L14.634083,11.5070111 L14.634083,35.4450111 L10.289083,35.4450111 L10.289083,12.8420111 Z"
                      id="Path_11046"
                    ></path>
                    <path
                      d="M22.311083,5.48454559e-06 C22.6453805,-0.0006661606 22.9769326,0.060355702 23.289083,0.18001106 C23.5890472,0.291163026 23.8637637,0.461160854 24.097083,0.68001106 C24.3223521,0.893073418 24.5067231,1.14556672 24.641083,1.42501106 C24.7778437,1.70912363 24.8479574,2.0207018 24.8461196,2.33601106 C24.8461196,2.64310728 24.776039,2.94615788 24.641083,3.22201106 C24.5067231,3.5014554 24.3223521,3.7539487 24.097083,3.96701106 C23.8627162,4.18794891 23.588526,4.36237192 23.289083,4.48101106 C22.9788881,4.60895111 22.6466266,4.67485983 22.311083,4.67502093 C21.9794143,4.67594697 21.6509299,4.6103181 21.345083,4.48201106 C21.0489804,4.36151744 20.7777433,4.18724763 20.545083,3.96801106 C20.3198128,3.75517944 20.1357331,3.50262082 20.002083,3.22301106 C19.8662751,2.94742067 19.7957855,2.64424674 19.7960406,2.33701106 C19.7940594,2.02157368 19.8645392,1.70988873 20.002083,1.42601106 C20.1369277,1.14607871 20.3223795,0.89349804 20.549083,0.68101106 C20.7806209,0.463806905 21.0523829,0.293955651 21.349083,0.18101106 C21.6555445,0.0608241985 21.9818974,-0.000578996354 22.311083,5.48454559e-06 M20.187083,12.8420111 L23.252083,11.5070111 L24.532083,11.5070111 L24.532083,35.4450111 L20.187083,35.4450111 L20.187083,12.8420111 Z"
                      id="Path_11047"
                    ></path>
                  </g>
                </g>
              </svg>
            </Link>
          )}
        </span>
        <nav className="flex flex-grow ">
          {noreactrouter ? (
            <ul className="hidden lg:flex justify-evenly items-center flex-grow h-full ">
              <li>
                <a className="relative hover:font-bold" href="/artists/">
                  artists
                </a>
              </li>
              <li>
                <a className="relative hover:font-bold" href="/hosted-program/">
                  hosted program
                </a>
              </li>
              <li>
                <a className="relative hover:font-bold" href="/agency/">
                  agency
                </a>
              </li>
              <li>
                <a className="relative hover:font-bold" href="/education/">
                  education
                </a>
              </li>
              <li>
                <a
                  className="relative hover:font-bold"
                  href="/projects/?c=editions"
                >
                  editions
                </a>
              </li>
            </ul>
          ) : (
            <>
              <ul className="hidden lg:flex justify-evenly items-center flex-grow h-full ">
                <li>
                  <MyLink
                    activeClassName="font-bold active"
                    className="relative hover:font-bold"
                    to="/artists/"
                  >
                    artists
                  </MyLink>
                </li>
                <li>
                  <MyLink
                    activeClassName="font-bold active"
                    className="relative hover:font-bold"
                    to="/hosted-program/"
                  >
                    hosted program
                  </MyLink>
                </li>
                <li>
                  <MyLink
                    activeClassName="font-bold active"
                    className="relative hover:font-bold"
                    to="/agency/"
                  >
                    agency
                  </MyLink>
                </li>
                <li>
                  <MyLink
                    activeClassName="font-bold active"
                    className="relative hover:font-bold"
                    to="/education/"
                  >
                    education
                  </MyLink>
                </li>
                <li>
                  <MyLink
                    activeClassName="font-bold active"
                    className="relative hover:font-bold"
                    to="/projects/?c=editions"
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      const queryParams = new URLSearchParams(location.search);
                      const cat = queryParams.get("c") ? queryParams.get("c") : "";
                      return cat == "editions";
                    }}
                  >
                    editions
                  </MyLink>
                </li>
              </ul>
              {metaCtx.translation && (
                <ul className="hidden lg:flex justify-evenly items-center h-full w-24 border-l-2 ">
                  <li>
                    <LanguageSelect />
                  </li>
                </ul>
              )}
            </>
          )}

          <div className="flex w-full lg:hidden justify-center items-center h-full ">
            <h2>{metaCtx.title}</h2>
          </div>
        </nav>

        <span className="lg:hidden w-14 h-full border-l-2 flex justify-center items-center">
          <MobileNavigation
            menuItems={menuItems}
            noreactrouter={noreactrouter}
          />
        </span>
      </header>
      {/*<SidebarNavigation menuItems={menuItems} noreactrouter={noreactrouter} />*/}
    </>
  );
};

export default Navigation;
